import { React, useState, useRef } from "react";
import ContactPopup from "../ContactPopup";
// import "./IECRegistration.css";
import "../PrivateLimitedCompany.css"

const IECRegistration = () => {
   const [openPopup, setOpenPopup] = useState(false);

    const contactRef = useRef(null);

    const scrollToContact = () => {
        contactRef.current?.scrollIntoView({ behavior: "smooth" });
    }

  return (
    <div className="page">

      {/* HERO */}
      <div className="hero">

        <h1>IEC Certificate Registration</h1>

        <p className="subtitle">
          Get Your Import Export Code (IEC) Quickly & Easily
        </p>

        <p className="desc">
          An IEC (Import Export Code) is mandatory for anyone who wants to import or export goods or services from India. We help you get your IEC certificate fast, online, and hassle-free.
        </p>

        <div className="badges">
          <span>✔ Quick Online Process</span>
          <span>✔ Lifetime Validity</span>
          <span>✔ Expert Assistance</span>
          <span>✔ No Physical Documents Required</span>
        </div>

<div className="hero-action">
                    <button className="hero-btn" onClick={scrollToContact}>
                        Get Started Today
                    </button>
                </div>

      </div>

      {/* WHAT IS IEC */}
      <div className="section">
        <h2>What is an IEC Certificate?</h2>
        <p>
          The Import Export Code (IEC) is a 10-digit registration issued by the Directorate General of Foreign Trade (DGFT). It is required for businesses involved in international trade of goods and services.
        </p>
      </div>

      {/* BENEFITS */}
      <div className="section">
        <h2>Benefits of IEC Certificate</h2>
        <ul>
          <li>Mandatory for import & export business</li>
          <li>Lifetime validity (no renewal required)</li>
          <li>Easy international trade transactions</li>
          <li>Enables global business expansion</li>
          <li>Required for customs clearance</li>
          <li>Access to export incentives</li>
        </ul>
      </div>

      {/* WHO NEEDS */}
      <div className="section">
        <h2>Who Needs IEC?</h2>
        <ul>
          <li>Exporters of goods or services</li>
          <li>Importers of goods</li>
          <li>E-commerce sellers (international shipping)</li>
          <li>Freelancers receiving foreign payments</li>
          <li>Manufacturers expanding globally</li>
        </ul>
      </div>

      {/* DOCUMENTS */}
      <div className="section">
        <h2>Documents Required</h2>
        <ul>
          <li>PAN Card</li>
          <li>Aadhaar Card</li>
          <li>Business Address Proof</li>
          <li>Bank Account Details</li>
          <li>Cancelled Cheque</li>
          <li>Email ID & Mobile Number</li>
        </ul>
      </div>

      {/* PROCESS */}
      <div className="section">
        <h2>IEC Registration Process</h2>
        <ul>
          <li>Consultation – Share business details</li>
          <li>Document Submission</li>
          <li>Online Application Filing (DGFT Portal)</li>
          <li>Verification by authority</li>
          <li>IEC Certificate Issued</li>
        </ul>
      </div>

      {/* WHY US */}
      <div className="section">
        <h2>Why Choose Us?</h2>
        <ul>
          <li>Fast Processing (1–3 days)</li>
          <li>Expert DGFT Assistance</li>
          <li>Affordable Pricing</li>
          <li>100% Online Process</li>
          <li>Dedicated Support Team</li>
        </ul>
      </div>

      {/* FAQ */}
      <div className="section">
        <h2>FAQs</h2>

        <p><b>Is IEC mandatory?</b> Yes, for all import/export businesses.</p>
        <p><b>Does IEC expire?</b> No, it has lifetime validity.</p>
        <p><b>Can individuals apply?</b> Yes, both individuals and businesses can apply.</p>
        <p><b>Is GST required?</b> Not mandatory but recommended.</p>

      </div>

      {/* CTA */}
      <div className="cta" ref={contactRef}>
        <h2>Get Your IEC Certificate Today</h2>
        <p>Start your import-export journey with expert support.</p>

                      <div className="cta-buttons">
                <button onClick={() => setOpenPopup(true)}>Contact Us Now</button>
                <ContactPopup
                  isOpen={openPopup}
                  onClose={() => setOpenPopup(false)}
                />
      
                <button className="outline" onClick={() => window.location.href = "tel:9218103915"} >Free Consultation</button>
              </div>

      </div>

    </div>
  );
};

export default IECRegistration;